"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBroadcastsAvailabilitySaga = fetchBroadcastsAvailabilitySaga;
exports.fetchBroadcastSaga = fetchBroadcastSaga;
exports.broadcastProviderSaga = broadcastProviderSaga;
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../LanguagesProvider/selectors");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/broadcast/api");
const slice_1 = require("./slice");
function* fetchBroadcastsAvailabilitySaga(action) {
    const { reqData, sideEffects } = action.payload;
    try {
        const { data: resData } = yield (0, effects_1.call)(api_1.getEventsBroadcastsAvailability, reqData);
        yield (0, effects_1.put)(slice_1.broadcastProviderActions.fetchBroadcastsAvailabilitySuccess({ resData }));
        if (sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) {
            yield (0, effects_1.put)(sideEffects.onSuccess({ reqData, resData }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching broadcasts', error);
        yield (0, effects_1.put)(slice_1.broadcastProviderActions.fetchBroadcastsAvailabilityError(error));
        if (sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) {
            yield (0, effects_1.put)(sideEffects.onError(error));
        }
    }
}
function* fetchBroadcastSaga(action) {
    const { reqData, sideEffects } = action.payload;
    try {
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const requestData = {
            locale,
            ...reqData,
        };
        const { data: resData } = yield (0, effects_1.call)(api_1.getEventBroadcast, requestData);
        yield (0, effects_1.put)(slice_1.broadcastProviderActions.fetchBroadcastSuccess({ resData }));
        if (sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) {
            yield (0, effects_1.put)(sideEffects.onSuccess({ reqData, resData }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching broadcast', error);
        yield (0, effects_1.put)(slice_1.broadcastProviderActions.fetchBroadcastError(error));
        if (sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) {
            yield (0, effects_1.put)(sideEffects.onError(error));
        }
    }
}
function* broadcastProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeEvery)(slice_1.broadcastProviderActions.fetchBroadcastsAvailability.type, fetchBroadcastsAvailabilitySaga),
        (0, effects_1.takeEvery)(slice_1.broadcastProviderActions.fetchBroadcast.type, fetchBroadcastSaga),
    ]);
}
//# sourceMappingURL=saga.js.map